export function getTimeInSeconds() {
  return Math.round(new Date().getTime() / 1000);
}
